import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { RouterService } from '@app/routing/router.service';
import { StringMap } from '@app/utils/string-map';
import { toggleClass } from '@app/utils/toggle-class';

@Injectable({
  providedIn: 'root',
})
export class SubNavService {
  private activeMap: StringMap<boolean> = {};
  private animationFrame?: number;

  constructor(
    private authenticationService: AuthenticationService,
    private routerService: RouterService
  ) {
    this.authenticationService.isAuthenticated$.subscribe(() => {
      this.reset();
    });

    this.routerService.routeChanged$.subscribe(() => {
      // Reset the active map otherwise it can happen that a sub-nav is considered even if it no
      // longer exists
      this.activeMap = {};
    });
  }

  /**
   * Reset the active map and remove the class.
   */
  public reset() {
    this.activeMap = {};

    this.toggleClass(false);
  }

  /**
   * Toggle the visibility of the sub-nav.
   *
   * @param id Some identifier
   * @param active If the sub-nav for the id is active
   */
  public toggle(id: string, active: boolean) {
    this.activeMap[id] = active;

    if (this.animationFrame != null) {
      cancelAnimationFrame(this.animationFrame);
    }

    this.animationFrame = requestAnimationFrame(() => {
      const anyActive = Object.values(this.activeMap).reduce((a, b) => a || b, false);

      this.toggleClass(anyActive);
    });
  }

  private toggleClass(show: boolean): void {
    toggleClass('sub-nav-visible', document.body, show);
  }
}
